module.exports = __webpack_public_path__ + "static/media/account-selected.22bc4fcf.svg";